import axios, { AxiosRequestConfig } from "axios";
import { QueryObserverResult, RefetchOptions, RefetchQueryFilters, useMutation, useQuery, useQueryClient } from "react-query";
import { useRecoilValue } from "recoil";

type ApiState = {
    method : "get" | "post" | "put",
    url: string,
    apiName: string,
    params?: any,
    body?: any
    time: number | false;
    async : boolean;
    focus?: boolean; 
}

const instance = axios.create();

export const UseApi = ({method, url, apiName, params, body, time, async, focus}: ApiState) => {
    
    const config: AxiosRequestConfig = { method: method, url: url, params: params, data: body };
    
    if( focus  == undefined ) {
        focus = false;
    }
    const { status, isLoading, isSuccess, data, error, remove, refetch } = useQuery(
        apiName, //queryKey 캐싱에 이용됨
        async () => {

            const { data } = await instance(config); // 에러일시 useQuery 리턴  error에 데이터 담김 maybe throw error와 동일 동작이지 않을까 싶음
            // error 발생하면 해당 query의 error에 데이터가 들어가게됨,
            // 아래 코드 있으면 error이후 새로고침 없이 query(위 instance(config))가 성공일지라고  if 문 조건이 true이기 때문에 throw 되버리고 data를 리턴받지 못함
            // 성고하면  error 객체 데이터 사라짐
            // if(error) {
            //     throw error;
            // }
            
            return data;
        },
        { 
            enabled : !!async, //enabled 는 쿼리가 자동으로 실행되지 않도록
            // onSuccess: data => {
            //     // 성공시 호출
            //     // console.log("성공");
            //     console.log(data);
            //     return data;
            // },
            staleTime: 0,
            cacheTime: 0,
            // 지정한 시간에 따라 refetch, 1000 = 1 secound, false일경우 동작 안함
            refetchInterval: time, 
            // 렌더 중에 사용 중인 속성을 알아서 추적하고 사용 중인 속성들이 변화가 있을 때에만 리렌더링
            notifyOnChangeProps: 'tracked',
            retry: false ,
            // 데이터가 stale 상태일 경우 윈도우 포커싱 될 때 마다 refetch를 실행
            refetchOnWindowFocus: focus,
            // 데이터가 stale 상태일 경우 마운트 시 마다 refetch를 실행
            // refetchOnMount: false,
            // 데이터가 stale 상태일 경우 재 연결 될 때 refetch를 실행
            // refetchOnReconnect: false
        }
    )
      
    // isLoading: api호출 상태 boolean
    // data: api호출 후 받는 data
    // remove: use-query 삭제
    // refetch: 호출한 api 재 호출
    return { status, isLoading, isSuccess, data, error, remove, refetch };
}
